import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .section {
    display: flex;
    flex-direction: column;
  }

  .section-title {
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-scale-03);
    font-style: normal;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 120%;
    margin: 0;
  }

  .section-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
    padding-top: var(--sds-size-space-800);
  }

  .section-subtitle {
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
    margin: 4px 0 0;
  }

  .header-text {
    display: flex;
    flex-direction: column;
  }

  .collapsible-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    cursor: pointer;
    color: inherit;
    font: inherit;
    text-align: left;
    -webkit-tap-highlight-color: transparent;
  }

  .collapsible-header:focus-visible {
    outline: 2px solid var(--sds-color-border-brand-default);
    outline-offset: 4px;
    border-radius: var(--sds-size-radius-200);
  }

  .toggle-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sds-color-text-default-secondary);
    flex-shrink: 0;
    transition: transform 0.3s ease;
    height: calc(var(--sds-typography-scale-03) * 1.2);
  }

  .toggle-icon.expanded {
    transform: rotate(180deg);
  }

  .collapsible-content {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.3s ease;
  }

  .collapsible-content.expanded {
    grid-template-rows: 1fr;
    padding-top: var(--sds-size-space-800);
  }

  .collapsible-content > ::slotted(*) {
    overflow: hidden;
  }
`;
